export enum UserMenuEnum {
    MY_DETAILS = 'myDetails',
    EARNINGS = 'earnings',
    WITHDRAWALS = 'withdrawals',
    BILLING_INFO = 'billingInfo',
    PROMO_CODES = 'promoCodes',
    REFERRAL_PROGRAM = 'referral',
    USER_PROFILE = 'userProfile',
}
